import React from 'react';
import Footer from '../components/Footer';
import { SEO } from '../components/SEO';

const LAST_UPDATED = 'October 9, 2026';

const CookiePolicy = () => (
  <>
    <SEO
      title="Cookie Policy"
      description="Which cookies and similar technologies dopove.com uses, why, and how to change your choice about live chat."
      canonical="https://dopove.com/cookie-policy"
    />
    <div className="bg-[#191d2b] min-h-screen text-[#fefdfe] flex flex-col font-sans selection:bg-[#e1dabe]/30">
      <main className="flex-1 pt-20">
        <div className="max-w-3xl mx-auto px-6 py-16 space-y-12">
          <header className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight">Cookie Policy</h1>
            <p className="text-[#fefdfe]/60">Last Updated: {LAST_UPDATED}</p>
            <p className="text-[#fefdfe]/70">
              This policy explains the cookies and similar technologies on dopove.com. It supplements our Privacy Policy.
            </p>
          </header>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold tracking-tight">Strictly necessary</h2>
            <p className="text-[#fefdfe]/70">
              We store your sign-in session (Amazon Cognito) when you sign in, and your live-chat choice in your browser's local storage so we do not ask again on every visit. These are needed to provide what you asked for and do not require consent.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold tracking-tight">Live chat (only if you allow it)</h2>
            <p className="text-[#fefdfe]/70">
              Zoho SalesIQ provides our live chat. It sets its own cookies and processes your chat messages and technical data about your visit. It does not load until you click Allow chat. If you choose No thanks, nothing from Zoho is loaded.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold tracking-tight">Analytics and advertising</h2>
            <p className="text-[#fefdfe]/70">We do not use analytics or advertising cookies on this site.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold tracking-tight">Changing your choice</h2>
            <p className="text-[#fefdfe]/70">
              Use Chat preferences in the footer at any time to be asked again. If chat is already loaded, the page reloads so the widget is removed when you decline. You can also clear cookies and site data in your browser settings.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  </>
);

export default CookiePolicy;
